import React from "react";
import {
  QueryActiveTrackMap,
  QueryAvailableCircuits,
  SubscribeNewActiveTrackMap,
} from "../../../utils/graphql/hooks/trackMapHooks";

export default function TrackMapDataManager() {
  QueryActiveTrackMap();
  QueryAvailableCircuits();
  SubscribeNewActiveTrackMap();
  return <></>;
}
